import { render, staticRenderFns } from "./ScaleView.vue?vue&type=template&id=67d8587e&"
import script from "./ScaleView.vue?vue&type=script&lang=js&"
export * from "./ScaleView.vue?vue&type=script&lang=js&"
import style0 from "./ScaleView.vue?vue&type=style&index=0&id=67d8587e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d8587e')) {
      api.createRecord('67d8587e', component.options)
    } else {
      api.reload('67d8587e', component.options)
    }
    module.hot.accept("./ScaleView.vue?vue&type=template&id=67d8587e&", function () {
      api.rerender('67d8587e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/element-view/ScaleView.vue"
export default component.exports